
<template>
  <div>
    <div class="commonBox projectBox">
      <div class="searchLine">
         <!-- 搜索框 -->
         <form action="">
          <van-search v-model="keywords" shape="round" background="transparent" placeholder="搜索姓名" @search="onSearch" />
         </form>
         <div class="showNum">
          {{allNum}}笔 | <span class="colorNum">{{totalMoney}}元</span>
         </div>
      </div>
      <div class="tabBox">
        <div :class="activeTab==item.id?'tabItem activeTab':'tabItem'" v-for="(item,i) in tabList" :key="i" @click="changeTab(item.id)">{{item.name}}</div>
      </div>
     
    </div>
    <!-- 全部项目列表 -->
    <div class="listBox">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <ul class="projectList">
            <li class="projectItem" v-for="(item,i) in list" :key="i" @click="goDetail(item.id,item.item_id)">
              <div class="projectDetail">
                <div class="rankingBox" v-if="i==0">
                  <img src="../assets/one.png" class="rankingImg">
                  <div class="imgBox firstColor">
                    <img :src="item.avatar?item.avatar:defaultImage" class="coverImg">
                  </div>
                </div>
                <div class="rankingBox" v-else-if="i==1">
                  <img src="../assets/two.png" class="rankingImg">
                  <div class="imgBox secondColor" >
                    <img :src="item.avatar?item.avatar:defaultImage" class="coverImg">
                  </div>
                </div>
                <div class="rankingBox" v-else-if="i==2">
                  <img src="../assets/three.png" class="rankingImg">
                  <div class="imgBox threeColor">
                    <img :src="item.avatar?item.avatar:defaultImage" class="coverImg">
                  </div>
                </div>
                <div class="imgBox" v-else>
                  <img :src="item.avatar?item.avatar:defaultImage" class="coverImg">
                </div>
                <div class="contentBox">
                  <div class="itemTitle">{{item.username}} <van-icon name="arrow" /> </div>
                  <div class="itemDis">{{item.nickname}}携{{ item.jk_num }}位好友捐赠 <span style="color:#000"> {{ item.donated_money }}</span>元</div>
                </div>
                <div class="timeBox">{{item.add_time}}</div>
              </div>
              <div class="msgBox"> <img src="../assets/msgColor.png" class="msgImg"> {{ item.slogan }}</div>
            </li>
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import {getTogetherList} from '@/api/index.js'
export default {
  name: 'moreDonateList',

  data() {
    return {
      projectId:"",
      togetherId:"",
      keywords: "",
      //tab栏
      tabList:[
        {id:'time',name:"默认"},
        {id:'money',name:"按捐款金额"},
      ],
      activeTab:'time',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      //分页信息
      pageIndex:0,
      totalNum:50,
      allNum:0,
      totalMoney:0,
      defaultImage:require('@/assets/avatar.png')
    };
  },

  mounted() {
    this.projectId = this.$route.query.id
    this.togetherId = this.$route.query.togetherId
  },

  methods: {
    //获取列表数据
    async getList(){
      let params ={
        username:this.keywords,
        sort_type:this.activeTab,
        page:this.pageIndex,
        item_id:this.projectId,
        together_id:this.togetherId
      }
      const res = await getTogetherList(params)
      if(res.status==200){
        this.allNum = res.data.all_num
        this.totalNum = res.data.total
        this.totalMoney = res.data.total_money
        this.list=[...this.list,...res.data.data]
        this.refreshing = false
        this.loading = false
      }else{
        this.$toast(res.err_msg)
      }
    },
    //去往详情页面
    goDetail(id,item_id) {
      console.log('to shared id=',id,'item_id=',item_id)
      this.$router.push({ path: `/project/share?itemId=${item_id}&together_id=${id}` });
    },
    //切换tab
    changeTab(id){
      this.activeTab = id
      this.list = [];
      this.pageIndex = 1;
      this.getList();
    },
    //搜索事件
    onSearch() {
      this.list = [];
      this.pageIndex = 1;
      this.getList();
    },
    // 获取列表数据
    onLoad() {
      if (this.list.length < this.totalNum) {
        console.log(this.pageIndex, "第几页");
        this.pageIndex += 1;
        this.getList();
      } else {
        this.finished = true;
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageIndex = 1;
      this.list = [];
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.projectBox {
  height: 250rem;
  overflow: hidden;
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
}
.searchLine{
  display: flex;
  align-items: center;
}
::v-deep .van-field__left-icon .van-icon {
  color: #b8211a !important;
  font-weight: 700;
}

::v-deep .van-search {
  padding: 45rem 40rem 30rem;
  width: 360rem;
}

::v-deep .van-search__content {
  background: #fff;
}
.showNum{
  flex:1;
  padding-right: 40rem;
  font-size:28rem;
  text-align: right;
  font-weight: 600;
}
.tabBox{
  display: flex;
  width: 670rem;
  margin:0 auto;
  font-size: 26rem;
  font-weight: 700;
  border-radius: 8rem;
  border: 1px solid #b8211a;
  .tabItem{
    width: 50%;
    height: 72rem;
    line-height: 72rem;
    text-align: center;
  }
  .activeTab{
    color:#fff;
    border-radius: 8rem;
    background-color: #b8211a;
  }
}
.listBox {
  width: 100%;
  margin-top: 250rem;
  padding: 45rem 40rem;

  .projectItem {
    width: 100%;
    padding: 30rem 0;
    border-bottom: 1px solid #e7e7e7;

    .projectDetail {
      display: flex;
      .rankingBox{
        position: relative;
        .rankingImg{
          position: absolute;
          top: -20rem;
          right:24rem;
          width: 44rem;
          height: 39rem;
        }
      }
      .imgBox {
        width: 110rem;
        height: 110rem;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 55rem;
        margin-right: 30rem;
        border: 5rem solid #fff;
        .coverImg {
          width: 100%;
        }
      }
      .firstColor{
        border-color: #c44742;
      }
      .secondColor{
        border-color: #f6c303;
      }
      .threeColor{
        border-color: #8cb5e6;
      }
      .contentBox {
        flex: 1;
        padding:10rem 0;
        .itemTitle {
          width: 100%;
          font-size: 26rem;
          color: #1b1b1b;
          font-weight: 700;
          margin-bottom: 10rem;
        }

        .itemDis {
          width: 100%;
          font-size: 22rem;
          color: #7f7f7f;
        }

        .itemNum {
          display: flex;
          justify-content: space-between;

          .itemNumLeft {
            display: flex;
            align-items: center;

            .doneMoney {
              width: 48rem;
              height: 30rem;
              text-align: center;
              line-height: 30rem;
              border-radius: 8rem;
              color: #f79d01;
              font-size: 18rem;
              border: 1rem solid #f79d01;
              margin-right: 10rem;
            }
          }
          .moneyNum {
            font-size: 24rem;
            color: #3c3c3c;
            font-weight: 600;
          }
        }
      }
    }
  }
}
.timeBox{
  font-size: 22rem;
  color: #808080;
  padding-top: 10rem;
}
.colorNum {
  color: #b8211a;
}
.msgBox{
  margin-top: 15rem;
  padding-left: 105rem;
  display: flex;
  align-items: center;
  font-size: 20rem;
  .msgImg{
    width: 28rem;
    height: 28rem;
    margin-right: 20rem;
  }
}
</style>